export default __webpack_public_path__ + "static/media/11.15459965.gif";